module.exports = __webpack_public_path__ + "img/106.6.af5d98e5.png";